<template>
  <div class='brand-home'>
    <Announcement @setMainContent="setMainContent"></Announcement>
    <Quick @itemClick="itemClick" :cmsConfig="cmsConfig"/>
    <ModalManage @menuChange="menuChange" />
    <div class="row-container gap-m-t">
      <div class="col-1_6 gap-m-r">
        <sales-rank />
      </div>
      <div class="col-1">
        <brand-info />
      </div>
    </div>
    <div class="row-container gap-m-t">
      <div class="col-1">
        <sales-data />
      </div>
    </div>
    <div class="row-container gap-m-t" v-if="cmsConfig.banner && cmsConfig.banner.length > 0">
      <Banner />
    </div>
    <div class="row-container gap-m-t">
      <div class="gap-m-r" style="flex: 1.3">
        <MarketingTools panelPaddingBottom="10px" />
      </div>
      <div class="col-1">
        <biz-school />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Quick from './components/quick'
import ModalManage from '../common/modal-manage'
import Announcement from '../common/announceInfo/newAnnounce'
import Salesdata from './components/salesdata'
import Salesrank from './components/salesrank'
import Brandinfo from './components/brandinfo'
import Banner from '../common/banner'
import MarketingTools from '../common/marketingTool'
import School from '../common/school'

export default {
  name: "home-brand",
  methods: {
    setMainContent(component) {
      this.$emit('setMainContent', component)
    },
    itemClick (link) {
      this.$emit('itemClick', link)
    },
    menuChange(item) {
      this.$emit('menuChange', item)
    },
  },
  computed: {
    ...mapState(['cmsConfig']),
  },
  components: {
    Announcement,
    Quick,
    ModalManage,
    [Salesdata.name]: Salesdata,
    [Salesrank.name]: Salesrank,
    [Brandinfo.name]: Brandinfo,
    Banner,
    MarketingTools,
    [School.name]: School,
  }
}
</script>
<style lang="scss" scoped>
.brand-home .common-panel-container {
  height: 100%;
}
.key-btn-container {
  a, span {
    color: #1C7AE5;
    cursor: pointer;
    margin-left: 20px;
  }
}
.row-container {
  display: flex;
  .col-1 {
    flex: 1;
  }
  .col-1_6 {
    flex: 1.6;
  }
}
.gap-m-r {
  margin-right: 15px;
}
.gap-m-t {
  margin-top: 15px;
}
</style>
